import { z } from 'zod';
import {
  AR_TASKS_MAX_PAGE_SIZE,
  ArTasksAgingBucketSchema,
  ArTasksGroupBySchema,
  ArTasksSortBySchema,
  ArTasksTabSchema,
  SortDirectionSchema,
  thenSortSchema,
} from '@erp/rpc';

/** URL state for the AR Tasks page: every filter is shareable. */
export const ArTasksSearchSchema = z.object({
  tab: ArTasksTabSchema.optional(),
  search: z.string().optional(),
  assignedToMe: z.boolean().optional(),
  /** A link from before the buckets changed (e.g. 3-7) shows every age. */
  aging: ArTasksAgingBucketSchema.optional().catch(undefined),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  page: z.number().int().min(1).optional(),
  pageSize: z.number().int().min(1).max(AR_TASKS_MAX_PAGE_SIZE).optional(),
  /** Table view: grouped by assignee; the flat list when unset. */
  groupBy: ArTasksGroupBySchema.optional(),
  /** Column sort (header click; shift-click adds a level). A stale link falls back to the default. */
  sortBy: ArTasksSortBySchema.optional().catch(undefined),
  sortDirection: SortDirectionSchema.optional().catch(undefined),
  thenSort: thenSortSchema(ArTasksSortBySchema).optional().catch(undefined),
  /** Open task in the list-detail split. */
  taskId: z.uuid().optional(),
});

export type ArTasksSearch = z.infer<typeof ArTasksSearchSchema>;

export const AR_TASKS_DEFAULT_PAGE_SIZE = 50;
